"use strict";
exports.__esModule = true;
var angular = require("angular");
require('./recalc-main.component.css');
var COMPONENT_NAME = 'smartorg.r6.navs.recalcMain';
var RECALC_TYPES = {
    all: 'all',
    unlocked: 'unlocked',
    invalid: 'invalid'
};
var ORPHAN_STATUS = {
    notFixed: 'notFixed',
    fixing: 'fixing',
    fixed: 'fixed'
};
var ALERT_TYPE = {
    success: 'success',
    danger: 'danger',
    warning: 'warning'
};
function generateTimeStamp() {
    return new Date().toLocaleString();
}
var RecalcMainComponent = /** @class */ (function () {
    function RecalcMainComponent($scope, $timeout) {
        var _this = this;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.reloadAction = function () {
            $scope.$emit('workbench:reloadAction');
        };
        $scope.$on('recalc_main:refresh', function (event, args) {
            $timeout(function () {
                _this.reset();
                $scope.$apply();
            });
        });
    }
    RecalcMainComponent.prototype.$onChanges = function () {
        this.reset();
        this.recalcType = RECALC_TYPES.unlocked;
    };
    RecalcMainComponent.prototype.showAlert = function (type, title, message) {
        this.showAlertService({ input: { type: type, title: title, message: message } });
    };
    RecalcMainComponent.prototype.reset = function () {
        this.recalculating = false;
        this.recalculated = false;
        this.recalcResult = null;
        this.seriesId = null;
        this.orphanNodeCount = 0;
        this.orphanNodeStatus = ORPHAN_STATUS.notFixed;
        var rootNode = this.treeObj ? this.treeObj.treeData : null;
        var startNode = this.selectedNode || rootNode;
        this.editableLeaves = { showList: false, nodes: startNode ? startNode.getEditableLeaves() : [] };
        this.invalidLeaves = { showList: false, nodes: startNode ? startNode.getDataInvalidLeaves() : [] };
        this.allLeaves = { showList: false, nodes: startNode ? startNode.getAllLeaves() : [] };
    };
    RecalcMainComponent.prototype.toggleDetails = function (nodeDetails) {
        nodeDetails.showList = !nodeDetails.showList;
        if (nodeDetails.showList && !nodeDetails.breadcrumbs) {
            nodeDetails.breadcrumbs = nodeDetails.nodes.map(function (n) { return n.getBreadcrumb(); });
        }
    };
    RecalcMainComponent.prototype.showResultAlert = function (treeId, startNode, failedNodes) {
        var alertType = failedNodes.length > 0 ? ALERT_TYPE.danger : ALERT_TYPE.success;
        var title = '';
        if (startNode && startNode.parent) {
            if (startNode.isLeaf()) {
                title = startNode.name + " in " + treeId + " was recalculated.";
            }
            else {
                title = "Nodes under " + startNode.name + " in " + treeId + " were recalculated.";
            }
        }
        else {
            title = treeId + " was recalculated.";
        }
        var message = failedNodes && failedNodes.length ?
            'Some nodes failed to recalculate, please see the detail report.' : '';
        this.showAlert(alertType, title, message);
    };
    RecalcMainComponent.prototype.updateNodesDataValidity = function (nodeIds, failedNodes) {
        var ctrl = this;
        var timestamp = new Date().toISOString();
        var failedNodesId = (failedNodes || []).map(function (n) { return n._id; });
        nodeIds.forEach(function (id) {
            if (failedNodesId.indexOf(id) < 0) {
                ctrl.treeObj.nodeMap[id].isDataValid = true;
                ctrl.treeObj.nodeMap[id].lastRecalc = timestamp;
            }
        });
        var rootNode = null;
        if (ctrl.treeObj) {
            ctrl.treeObj.updateLeafParents();
            rootNode = ctrl.treeObj.treeData;
        }
        var startNode = ctrl.selectedNode || rootNode;
        ctrl.invalidLeaves = { showList: false, nodes: startNode ? startNode.getDataInvalidLeaves() : [] };
        ctrl.$scope.$apply();
    };
    RecalcMainComponent.prototype.startRecalc = function () {
        var ctrl = this;
        this.reset();
        this.recalculating = true;
        var startNode = this.selectedNode;
        var startNodeId = startNode ? startNode._id : '';
        var treeId = this.treeObj.treeName;
        var leavesToRecalc = this.recalcType === RECALC_TYPES.unlocked ? this.editableLeaves.nodes :
            this.recalcType === RECALC_TYPES.invalid ? this.invalidLeaves.nodes :
                this.allLeaves.nodes;
        var leaveNumber = leavesToRecalc.length;
        this.smartorgApi.recalculatePortfolio(treeId, this.recalcType, startNodeId, leaveNumber).then(function (response) {
            var _a = response.results, seriesId = _a.seriesId, _b = _a.recalcResults, successCount = _b.successCount, failedNodes = _b.failedNodes, timeConsumed = _b.timeConsumed, orphanNodes = _a.orphanNodes;
            ctrl.seriesId = seriesId;
            ctrl.recalcResult = { successCount: successCount, failedNodes: failedNodes, timeConsumed: timeConsumed, timestamp: generateTimeStamp() };
            ctrl.orphanNodeCount = orphanNodes;
            if (failedNodes && failedNodes.length) {
                var nodeMap_1 = ctrl.treeObj.nodeMap;
                ctrl.recalcResult.failedNodeBreadcrumbs = failedNodes.map(function (n) { return nodeMap_1[n._id].getBreadcrumb(); });
            }
            var nodeIds = leavesToRecalc.map(function (n) { return n._id; });
            ctrl.updateNodesDataValidity(nodeIds, failedNodes);
            ctrl.recalculated = true;
            ctrl.recalculating = false;
            ctrl.reloadAction();
            ctrl.$timeout(function () {
                ctrl.showResultAlert(treeId, startNode, failedNodes);
            });
        })["catch"](function (err) {
            ctrl.recalculated = true;
            ctrl.recalculating = false;
            ctrl.$timeout(function () {
                ctrl.showAlert(ALERT_TYPE.danger, "Server Error " + err.status, "Failed to recalculate. " + err.message);
            });
        });
    };
    RecalcMainComponent.prototype.recalcFailedNodes = function () {
        var _this = this;
        var ctrl = this;
        var treeId = this.treeObj.treeName;
        var nodeIds = this.recalcResult.failedNodes.map(function (n) { return n._id; });
        this.recalculating = true;
        this.recalculated = false;
        this.recalcResult = null;
        this.smartorgApi.recalculateNodes(treeId, nodeIds, ctrl.seriesId).then(function (response) {
            var _a = response.results.recalcResults, successCount = _a.successCount, failedNodes = _a.failedNodes, timeConsumed = _a.timeConsumed;
            ctrl.recalcResult = { successCount: successCount, failedNodes: failedNodes, timeConsumed: timeConsumed, timestamp: generateTimeStamp() };
            if (failedNodes && failedNodes.length) {
                var nodeMap_2 = ctrl.treeObj.nodeMap;
                ctrl.recalcResult.failedNodeBreadcrumbs = failedNodes.map(function (n) { return nodeMap_2[n._id].getBreadcrumb(); });
            }
            ctrl.updateNodesDataValidity(nodeIds, failedNodes);
            ctrl.recalculated = true;
            ctrl.recalculating = false;
            _this.$timeout(function () {
                ctrl.showResultAlert('Nodes', null, failedNodes);
            });
        })["catch"](function (err) {
            ctrl.recalculated = true;
            ctrl.recalculating = false;
            ctrl.$timeout(function () {
                ctrl.showAlert(ALERT_TYPE.danger, "Server Error " + err.status, "Failed to recalculate. " + err.message);
            });
        });
    };
    RecalcMainComponent.prototype.fixOrphanNodes = function () {
        var ctrl = this;
        var treeId = this.treeObj.treeName;
        this.orphanNodeStatus = ORPHAN_STATUS.fixing;
        this.smartorgApi.fixOrphanNodesCount(treeId).then(function (num) {
            ctrl.checkOrphanNodes();
            ctrl.orphanNodeStatus = ORPHAN_STATUS.fixed;
            ctrl.showAlert(ALERT_TYPE.success, num + " orphan nodes removed.", '');
        })["catch"](function (err) {
            ctrl.orphanNodeStatus = ORPHAN_STATUS.notFixed;
            ctrl.showAlert(ALERT_TYPE.danger, "Server Error " + err.status, "Failed to recalculate. " + err.message);
        });
    };
    RecalcMainComponent.prototype.checkOrphanNodes = function () {
        var ctrl = this;
        var treeId = this.treeObj.treeName;
        this.smartorgApi.getOrphanNodesCount(treeId).then(function (num) {
            ctrl.orphanNodeCount = num;
        })["catch"](function (err) {
            ctrl.showAlert(ALERT_TYPE.danger, "Server Error " + err.status, "Failed to recalculate. " + err.message);
        });
    };
    return RecalcMainComponent;
}());
angular.module(COMPONENT_NAME, []).component('recalcMain', {
    template: require('./recalc-main.component.html'),
    bindings: {
        smartorgApi: '=',
        showAlertService: '&',
        treeObj: '<',
        selectedNode: '<'
    },
    controller: RecalcMainComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=recalc-main.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/recalc/main/recalc-main.component.js